import { useEffect, useState } from "react";

export const useShiftHeld = () => {
  const [shiftHeld, setShiftHeld] = useState(false);

  useEffect(() => {
    const onKey = (event) => {
      setShiftHeld(Boolean(event.shiftKey));
    };
    const onBlur = () => setShiftHeld(false);
    window.addEventListener("keydown", onKey);
    window.addEventListener("keyup", onKey);
    window.addEventListener("blur", onBlur);
    return () => {
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("keyup", onKey);
      window.removeEventListener("blur", onBlur);
    };
  }, []);

  return shiftHeld;
};
